module.exports = __webpack_public_path__ + "img/album18_36.4475552d.jpg";